module.exports = __webpack_public_path__ + "static/media/satellite-dish.945c7cd8.svg";